












import { defineComponent } from "@vue/composition-api";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { QuestionaryInfo } from "@teacherskaya/api-provider/dist/api/QuestionaryInfoProvider";
import config from "@/config";
import { $t } from "@/lib/helpers/i18nHelper";
import providers from "@/lib/providers";
import { getQuestionaryInfoFields } from "@/lib/questionaryFieldsHelper";
import { FormFields, FormValues } from "@/types";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BlockBaseView from "@/components/BlockBaseView.vue";

export default defineComponent({
  name: "BlockQuestionaryInformation",
  components: { BlockBaseForm, BlockBase, BlockBaseView },
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data() {
    return {
      title: $t("Questionnaire"),
      editing: false,
      questionaryInfo: null as QuestionaryInfo | null,
    };
  },
  computed: {
    restrictedMember(): boolean {
      return false;
    },
    fields(): FormFields {
      return getQuestionaryInfoFields()
        .filter(item => (this.restrictedMember ? item.fieldMeta?.allowedForMember : true))
        .map(item => {
          item.value = this.questionaryInfo?.fields[item.name];
          return item;
        });
    },
    fieldsView(): FormFields {
      return this.fields.map(item => {
        let value;
        if (item.type === "checkbox") {
          value = this.questionaryInfo?.fields[item.name] ? $t("Yes") : $t("No");
        } else {
          value = this.questionaryInfo?.fields[item.name];
        }
        return { ...item, value };
      });
    },
    userId(): string {
      return this.user.id;
    },
  },
  methods: {
    async save(values: FormValues) {
      const data: QuestionaryInfo = {
        fields: {
          ...values,
          userId: this.userId,
        },
      };
      this.fields.map(item => {
        if (item.type === "checkbox") data.fields[item.name] = !!data.fields[item.name];
      });
      this.questionaryInfo = await providers.QuestionaryInfoProvider.update({ data });
      this.editing = false;
    },
    async getData() {
      this.questionaryInfo = await providers.QuestionaryInfoProvider.find({ id: this.userId });
    },
  },
  created() {
    this.getData();
  },
});
